// src/components/LazySection.js
import React, { useState, useEffect, useRef } from 'react';

const LazySection = ({ children, threshold = 0.1 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => observer.disconnect();
  }, [threshold]);
  
  return (
    <div ref={sectionRef}>
      {isVisible ? children : <div style={{ height: '300px' }} />}
    </div>
  );
};

export default LazySection;

// Usage in Home.js
//<LazySection>
//  <Suspense fallback={<LoadingSpinner message="Loading bio section..." />}>
//    <BioSection />
//  </Suspense>
//</LazySection>

